import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Mesh } from './Mesh.js';
import { Matrix4 } from '../math/Matrix4.js';
import { Vector3 } from '../math/Vector3.js';
import { Vector4 } from '../math/Vector4.js';

var _basePosition = /*@__PURE__*/new Vector3();

var _skinIndex = /*@__PURE__*/new Vector4();

var _skinWeight = /*@__PURE__*/new Vector4();

var _vector = /*@__PURE__*/new Vector3();

var _matrix = /*@__PURE__*/new Matrix4();

var SkinnedMesh = /*#__PURE__*/function (_Mesh) {
  _inherits(SkinnedMesh, _Mesh);

  var _super = _createSuper(SkinnedMesh);

  function SkinnedMesh(geometry, material) {
    var _this;

    _classCallCheck(this, SkinnedMesh);

    _this = _super.call(this, geometry, material);
    _this.type = 'SkinnedMesh';
    _this.bindMode = 'attached';
    _this.bindMatrix = new Matrix4();
    _this.bindMatrixInverse = new Matrix4();
    return _this;
  }

  _createClass(SkinnedMesh, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(SkinnedMesh.prototype), "copy", this).call(this, source);

      this.bindMode = source.bindMode;
      this.bindMatrix.copy(source.bindMatrix);
      this.bindMatrixInverse.copy(source.bindMatrixInverse);
      this.skeleton = source.skeleton;
      return this;
    }
  }, {
    key: "bind",
    value: function bind(skeleton, bindMatrix) {
      this.skeleton = skeleton;

      if (bindMatrix === undefined) {
        this.updateMatrixWorld(true);
        this.skeleton.calculateInverses();
        bindMatrix = this.matrixWorld;
      }

      this.bindMatrix.copy(bindMatrix);
      this.bindMatrixInverse.copy(bindMatrix).invert();
    }
  }, {
    key: "pose",
    value: function pose() {
      this.skeleton.pose();
    }
  }, {
    key: "normalizeSkinWeights",
    value: function normalizeSkinWeights() {
      var vector = new Vector4();
      var skinWeight = this.geometry.attributes.skinWeight;

      for (var i = 0, l = skinWeight.count; i < l; i++) {
        vector.x = skinWeight.getX(i);
        vector.y = skinWeight.getY(i);
        vector.z = skinWeight.getZ(i);
        vector.w = skinWeight.getW(i);
        var scale = 1.0 / vector.manhattanLength();

        if (scale !== Infinity) {
          vector.multiplyScalar(scale);
        } else {
          vector.set(1, 0, 0, 0); // do something reasonable
        }

        skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
      }
    }
  }, {
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(force) {
      _get(_getPrototypeOf(SkinnedMesh.prototype), "updateMatrixWorld", this).call(this, force);

      if (this.bindMode === 'attached') {
        this.bindMatrixInverse.copy(this.matrixWorld).invert();
      } else if (this.bindMode === 'detached') {
        this.bindMatrixInverse.copy(this.bindMatrix).invert();
      } else {
        console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
      }
    }
  }, {
    key: "boneTransform",
    value: function boneTransform(index, target) {
      var skeleton = this.skeleton;
      var geometry = this.geometry;

      _skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);

      _skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);

      _basePosition.copy(target).applyMatrix4(this.bindMatrix);

      target.set(0, 0, 0);

      for (var i = 0; i < 4; i++) {
        var weight = _skinWeight.getComponent(i);

        if (weight !== 0) {
          var boneIndex = _skinIndex.getComponent(i);

          _matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);

          target.addScaledVector(_vector.copy(_basePosition).applyMatrix4(_matrix), weight);
        }
      }

      return target.applyMatrix4(this.bindMatrixInverse);
    }
  }]);

  return SkinnedMesh;
}(Mesh);

SkinnedMesh.prototype.isSkinnedMesh = true;
export { SkinnedMesh };